import { gql } from 'apollo-boost';

export const ADD_CREDITS = gql`
    mutation ($data: AddCreditsInput!) {
        addCredits(data: $data) {
            __typename
            ... on AddCreditsSuccess {
                success
                newBalance
            }
            ... on AddCreditsError {
                message
            }
            ... on InternalServerError {
                message
            }
        }
    }
`;
